import {Connection, ConnectionType, Meter, MeterType} from '@flowmaps-com/flowmaps-typescriptmodels';

export function meterEnergyType(meter: Meter | undefined, connection: Connection): ConnectionType {
    return meter?.info?.type === MeterType.COOLING ? ConnectionType.Cooling : connection?.info?.connectionType as ConnectionType;
}

export function supportsContractType(connection: Connection, type: ConnectionType): boolean {
    return connection?.info?.connectionType === type
        || type === ConnectionType.Cooling && connection?.info?.connectionType === ConnectionType.Heat
        && connection.meters?.some(meter => meter.info.type === MeterType.COOLING);
}
